import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // This component tracks page views
    // In a production app, you would send this data to your analytics service
    if (process.env.NODE_ENV === 'development') {
      // console.log(`Page view: ${location.pathname}`);
    }
  }, [location]);

  return null;
};

export default AnalyticsTracker;